export const translations = {
  ru: {
    nav_home: 'Главная',
    nav_catalog: 'Каталог',
    nav_partner: 'Стать Партнером',
    nav_contact: 'Контакты',
    btn_contact: 'Связаться',
    btn_contact_us: 'Связаться с нами',
    hero_subtitle: 'ОсОО Явуз Бурак — Бишкек',
    hero_title2: 'Фасадные и интерьерные краски европейского качества',
    hero_desc: 'ОсОО Явуз Бурак — профессиональные лакокрасочные материалы для фасадов и интерьеров. Высокое качество, долговечность и доступная цена.',
    hero_btn_catalog: 'Каталог продукции',
    hero_hint: '↓ наведите на цвет, чтобы покрасить',
    about_label: 'О компании',
    about_title_1: 'YAVUZ BURAK —',
    about_title_2: '11 ЛЕТ КАЧЕСТВА',
    about_desc: 'ОсОО «Явуз Бурак» — современная производственная компания (основана в 2014 г.), развивающая собственные технологии в области лакокрасочных материалов. Мы создаём продукты линеек STORM PAINT, BM PAINT, GRANIT LINE, которые объединяют эстетичность, технологичность и устойчивость к климатическим условиям.',
    about_exp_title: 'Опыт',
    about_exp_text: '11 лет на рынке (с 2014 года).',
    about_prod_title: 'Производство',
    about_prod_text: 'Собственные технологии и рецептуры.',
    about_assort_title: 'Ассортимент',
    about_assort_text: 'Фасадные, интерьерные краски, декоративные покрытия.',
    about_partner_title: 'Партнерство',
    about_partner_text: 'Выгодные условия для дилеров (BM PARTNER).',
    team_title_1: 'Наша',
    team_title_2: 'Команда',
    team_desc: 'Профессионалы, стоящие за качеством YAVUZ BURAK',
    catalog_label: 'Каталог продукции',
    catalog_title_1: 'Популярные',
    catalog_title_2: 'решения',
    catalog_btn_all: 'Смотреть весь каталог',
    catalog_btn_more: 'Подробнее',
    areas_label: 'Сферы применения',
    areas_title_1: 'Где работают наши',
    areas_title_2: 'покрытия',
    contact_label: 'Контакты',
    contact_title_1: 'Свяжитесь с',
    contact_title_2: 'нами',
    contact_office: 'Наш офис',
    contact_phone: 'Телефон',
    contact_multichannel: 'Многоканальный',
    contact_email: 'Email',
    contact_workhours: 'Режим работы',
    contact_form_title: 'Оставить заявку',
    contact_form_success: 'Заявка отправлена!',
    contact_form_success_desc: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
    contact_form_btn_another: 'Отправить ещё одну заявку',
    contact_form_name: 'Ваше имя',
    contact_form_phone: 'Телефон',
    contact_form_msg: 'Сообщение',
    contact_form_submit: 'Отправить заявку',
    contact_form_policy: 'Нажимая кнопку, вы соглашаетесь с политикой обработки персональных данных',
    contact_form_err_name: 'Укажите ваше имя',
    contact_form_err_phone: 'Укажите номер телефона',
    contact_form_err_phone_invalid: 'Введите корректный номер',
    contact_name_placeholder: 'Иван Иванов',
    contact_msg_placeholder: 'Какая краска вас интересует?',
    footer_desc: 'Производим и поставляем высококачественные лакокрасочные материалы европейского качества для всех отраслей строительства.',
    footer_nav: 'Навигация',
    footer_products: 'Продукция',
    footer_write_us: 'Написать нам',
    footer_rights: '© {year} Yavuz Burak. Все права защищены.',
    footer_privacy: 'Политика конфиденциальности',
    footer_terms: 'Условия использования',
    footer_catalog_link: 'Каталог продукции',
    footer_areas_link: 'Сферы применения',
    footer_about_link: 'О компании',
    footer_contact_link: 'Контакты',
    footer_partner_link: 'Стать партнером',
    footer_facade: 'Фасадные краски',
    footer_interior: 'Интерьерные краски',
    footer_primers: 'Грунтовки',
    footer_betono: 'Бетоно-контакт',
    footer_micro: 'Микроцемент',
    order_title: 'Оформление заказа',
    order_product: 'Товар:',
    order_success_desc: 'Спасибо! Наш менеджер свяжется с вами в ближайшее время.',
    order_btn_close: 'Закрыть',
    order_qty_comment: 'Количество / Комментарий',
    order_err_name: 'Пожалуйста, укажите ваше имя',
    order_err_phone: 'Пожалуйста, укажите номер телефона',
    order_err_phone_invalid: 'Введите корректный номер телефона',
    order_comment_placeholder: 'Укажите необходимое количество или задайте вопрос...',
    cookie_title: 'Использование cookies',
    cookie_desc: 'Мы используем файлы cookie для улучшения работы сайта и анализа трафика. Продолжая использовать сайт, вы соглашаетесь с нашей',
    cookie_policy: 'политикой конфиденциальности',
    cookie_accept: 'Принять',
    cookie_decline: 'Отклонить',
    catalog_page_title_1: 'Каталог',
    catalog_page_title_2: 'Продукции',
    catalog_page_desc: 'Профессиональные решения для строительства и ремонта. Цены указаны без учета НДС и доставки.',
    catalog_page_order: 'Заказать',
    catalog_page_specs: 'Технические характеристики',
    catalog_category_all: 'Все продукты',
    catalog_view_product: 'Подробнее',
    catalog_line_variants: 'Выберите вариант',
    catalog_line_from: 'от',
    catalog_line_general: 'Обзор линейки',
    product_page_back: 'Назад к каталогу',
    product_page_advantages: 'Ключевые преимущества',
    product_page_description: 'Описание продукта',
    product_page_specs: 'Технические характеристики',
    product_page_order: 'Заказать',
    product_page_price_from: 'от',
    product_line_variants_title: 'Варианты линейки',
    product_line_details: 'Подробнее',
    product_line_order_variant: 'Заказать',
    product_line_from: 'от',
    contact_page_title_1: 'Наши',
    contact_page_title_2: 'Контакты',
    contact_page_desc: 'Мы всегда рады ответить на ваши вопросы и помочь с выбором продукции.',
    partner_form_company: 'Название компании',
    partner_form_contact: 'Контактное лицо',
    partner_form_region: 'Регион деятельности',
    partner_form_volume: 'Планируемый объём закупок',
    partner_form_volume_opt1: 'до 100 кг/мес',
    partner_form_volume_opt2: '100–500 кг/мес',
    partner_form_volume_opt3: '500–1000 кг/мес',
    partner_form_volume_opt4: 'более 1000 кг/мес',
    partner_form_info: 'Дополнительная информация',
    partner_form_sending: 'Отправка...',
    partner_form_err: 'Ошибка отправки. Пожалуйста, позвоните нам напрямую.',
    partner_success_desc: 'Спасибо за интерес к программе BM PARTNER. Наш менеджер свяжется с вами в течение 2 рабочих дней.',
    partner_form_select: 'Выберите объём',
    partner_form_placeholder_company: 'ООО «Ваша компания»',
    partner_form_placeholder_name: 'Иван Иванов',
    partner_form_placeholder_region: 'Бишкек, Ош, ...',
    partner_form_placeholder_info: 'Расскажите о вашем бизнесе, опыте работы с ЛКМ...'
  },
  ky: {
    nav_home: 'Башкы бет',
    nav_catalog: 'Каталог',
    nav_partner: 'Өнөктөш болуу',
    nav_contact: 'Байланыш',
    btn_contact: 'Байланышуу',
    btn_contact_us: 'Биз менен байланышыңыз',
    hero_subtitle: 'ЖЧК Явуз Бурак — Бишкек',
    hero_title2: 'Европа сапатындагы фасаддык жана интерьердик боёктор',
    hero_desc: 'ЖЧК Явуз Бурак — фасаддар жана интерьерлер үчүн кесипкөй лак-боёк материалдары. Жогорку сапат, узак мөөнөттүүлүк жана жеткиликтүү баа.',
    hero_btn_catalog: 'Продукция каталогу',
    hero_hint: '↓ боёо үчүн түстүн үстүнө барыңыз',
    about_label: 'Компания жөнүндө',
    about_title_1: 'YAVUZ BURAK —',
    about_title_2: '11 ЖЫЛДЫК САПАТ',
    about_desc: '«Явуз Бурак» ЖЧК — лак-боёк материалдары тармагында өз технологияларын өнүктүргөн заманбап өндүрүш компаниясы (2014-жылы негизделген). Биз эстетиканы, технологиялуулукту жана климаттык шарттарга туруктуулукту айкалыштырган STORM PAINT, BM PAINT, GRANIT LINE линияларынын продуктуларын жаратабыз.',
    about_exp_title: 'Тажрыйба',
    about_exp_text: 'Рынокто 11 жыл (2014-жылдан бери).',
    about_prod_title: 'Өндүрүш',
    about_prod_text: 'Өздүк технологиялар жана рецептуралар.',
    about_assort_title: 'Ассортимент',
    about_assort_text: 'Фасаддык, интерьердик боёктор, декоративдик каптоолор.',
    about_partner_title: 'Өнөктөштүк',
    about_partner_text: 'Дилерлер үчүн пайдалуу шарттар (BM PARTNER).',
    team_title_1: 'Биздин',
    team_title_2: 'Команда',
    team_desc: 'YAVUZ BURAK сапатынын артында турган кесипкөйлөр',
    catalog_label: 'Продукция каталогу',
    catalog_title_1: 'Популярдуу',
    catalog_title_2: 'чечимдер',
    catalog_btn_all: 'Бардык каталогду көрүү',
    catalog_btn_more: 'Кененирээк',
    areas_label: 'Колдонуу чөйрөлөрү',
    areas_title_1: 'Биздин каптоолор кайда',
    areas_title_2: 'иштейт',
    contact_label: 'Байланыш',
    contact_title_1: 'Биз менен',
    contact_title_2: 'байланышыңыз',
    contact_office: 'Биздин кеңсе',
    contact_phone: 'Телефон',
    contact_multichannel: 'Көп каналдуу',
    contact_email: 'Email',
    contact_workhours: 'Иштөө режими',
    contact_form_title: 'Билдирме калтыруу',
    contact_form_success: 'Билдирме жөнөтүлдү!',
    contact_form_success_desc: 'Рахмат! Биз сиз менен жакынкы арада байланышабыз.',
    contact_form_btn_another: 'Дагы бир билдирме жөнөтүү',
    contact_form_name: 'Сиздин атыңыз',
    contact_form_phone: 'Телефон',
    contact_form_msg: 'Билдирүү',
    contact_form_submit: 'Билдирмени жөнөтүү',
    contact_form_policy: 'Баскычты басуу менен, сиз жеке маалыматтарды иштеп чыгуу саясатына макулдугуңузду билдиресиз',
    contact_form_err_name: 'Атыңызды көрсөтүңүз',
    contact_form_err_phone: 'Телефон номерин көрсөтүңүз',
    contact_form_err_phone_invalid: 'Туура номерди киргизиңиз',
    contact_name_placeholder: 'Аты-жөнүңүз',
    contact_msg_placeholder: 'Кайсы боёк сизди кызыктырат?',
    footer_desc: 'Курулуштун бардык тармактары үчүн европалык сапаттагы жогорку сапаттагы лак-боёк материалдарын өндүрөбүз жана жеткиребиз.',
    footer_nav: 'Навигация',
    footer_products: 'Продукция',
    footer_write_us: 'Бизге жазыңыз',
    footer_rights: '© {year} Yavuz Burak. Бардык укуктар корголгон.',
    footer_privacy: 'Купуялык саясаты',
    footer_terms: 'Колдонуу шарттары',
    footer_catalog_link: 'Продукция каталогу',
    footer_areas_link: 'Колдонуу чөйрөлөрү',
    footer_about_link: 'Компания жөнүндө',
    footer_contact_link: 'Байланыш',
    footer_partner_link: 'Өнөктөш болуу',
    footer_facade: 'Фасаддык боёктор',
    footer_interior: 'Интерьердик боёктор',
    footer_primers: 'Грунтовкалар',
    footer_betono: 'Бетоно-контакт',
    footer_micro: 'Микроцемент',
    order_title: 'Буйрутманы жолжоболоштуруу',
    order_product: 'Товар:',
    order_success_desc: 'Рахмат! Биздин менеджер сиз менен жакынкы арада байланышат.',
    order_btn_close: 'Жабуу',
    order_qty_comment: 'Саны / Комментарий',
    order_err_name: 'Сураныч, атыңызды көрсөтүңүз',
    order_err_phone: 'Сураныч, телефон номерин көрсөтүңүз',
    order_err_phone_invalid: 'Туура телефон номерин киргизиңиз',
    order_comment_placeholder: 'Керектүү санын көрсөтүңүз же суроо бериңиз...',
    cookie_title: 'Cookies колдонуу',
    cookie_desc: 'Биз сайттын иштешин жакшыртуу жана трафикти талдоо үчүн cookie файлдарын колдонобуз. Сайтты колдонууну улантуу менен, сиз биздин',
    cookie_policy: 'купуялык саясатыбызга',
    cookie_accept: 'Кабыл алуу',
    cookie_decline: 'Четке кагуу',
    catalog_page_title_1: 'Каталог',
    catalog_page_title_2: 'Продукциясы',
    catalog_page_desc: 'Курулуш жана оңдоо үчүн кесипкөй чечимдер. Баалар КНС жана жеткирүүнү эсепке албаганда көрсөтүлгөн.',
    catalog_page_order: 'Буйрутма берүү',
    catalog_page_specs: 'Техникалык мүнөздөмөлөр',
    catalog_category_all: 'Бардык продуктылар',
    catalog_view_product: 'Кененирээк',
    catalog_line_variants: 'Вариантты тандаңыз',
    catalog_line_from: 'баштап',
    catalog_line_general: 'Линейкага сереп',
    product_page_back: 'Каталогго кайтуу',
    product_page_advantages: 'Негизги артыкчылыктар',
    product_page_description: 'Продукт сыпаттамасы',
    product_page_specs: 'Техникалык мүнөздөмөлөр',
    product_page_order: 'Буйрутма берүү',
    product_page_price_from: 'баштап',
    product_line_variants_title: 'Линейканын варианттары',
    product_line_details: 'Кененирээк',
    product_line_order_variant: 'Буйрутма берүү',
    product_line_from: 'баштап',
    contact_page_title_1: 'Биздин',
    contact_page_title_2: 'Байланыш',
    contact_page_desc: 'Биз сиздин суроолоруңузга жооп берүүгө жана продукцияны тандоого жардам берүүгө ар дайым кубанычтабыз.',
    partner_form_company: 'Компаниянын аталышы',
    partner_form_contact: 'Байланышчу адам',
    partner_form_region: 'Ишмердүүлүк аймагы',
    partner_form_volume: 'Пландаштырылган сатып алуу көлөмү',
    partner_form_volume_opt1: '100 кг/айга чейин',
    partner_form_volume_opt2: '100–500 кг/ай',
    partner_form_volume_opt3: '500–1000 кг/ай',
    partner_form_volume_opt4: '1000 кг/айдан ашык',
    partner_form_info: 'Кошумча маалымат',
    partner_form_sending: 'Жөнөтүлүүдө...',
    partner_form_err: 'Жөнөтүүдө ката кетти. Сураныч, бизге түз чалыңыз.',
    partner_success_desc: 'BM PARTNER программасына кызыкканыңыз үчүн рахмат. Биздин менеджер сиз менен 2 жумушчу күндүн ичинде байланышат.',
    partner_form_select: 'Көлөмдү тандаңыз',
    partner_form_placeholder_company: 'ЖЧК «Сиздин компания»',
    partner_form_placeholder_name: 'Аты-жөнүңүз',
    partner_form_placeholder_region: 'Бишкек, Ош, ...',
    partner_form_placeholder_info: 'Бизнесиңиз жөнүндө айтып бериңиз...'
  }
};
export type Language = 'ru' | 'ky';
export type TranslationKey = keyof typeof translations.ru;